import * as actionTypes from "./dashboardTypes";

const INITIAL_STATE = {
    generalSearchList: [],
    ordersList: [],
    myEquipmentList: [],
    invoicesList: [],
    deliveriesList: [],
    equipmentInfo: null,
    meterBillingInfo: [],
    serviceCallInfo: [],
    orderHistoryInfo: [],
};

const dashboardReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETGENERALSEARCHLIST:
            return {
                ...state,
                generalSearchList: action.payload.list,
            };
        case actionTypes.SETORDERSLIST:
            return {
                ...state,
                ordersList: action.payload.list,
            };
        case actionTypes.SETMYEQUIPMENTLIST:
            return {
                ...state,
                myEquipmentList: action.payload.list,
            };
        case actionTypes.SETINVOICESLIST:
            return {
                ...state,
                invoicesList: action.payload.list,
            };
        case actionTypes.SETDELIVERIESLIST:
            return {
                ...state,
                deliveriesList: action.payload.list,
            };
        case actionTypes.SETEQUIPMENTINFO:
            return {
                ...state,
                equipmentInfo: action.payload.list,
            };
        case actionTypes.SETMETERBILLINGINFO:
            return {
                ...state,
                meterBillingInfo: action.payload.list,
            };
        case actionTypes.SETSERVICECALLINFO:
            return {
                ...state,
                serviceCallInfo: action.payload.list,
            };
        case actionTypes.SETORDERHISTORYINFO:
            return {
                ...state,
                orderHistoryInfo: action.payload.list,
            };
        default:
            return state;
    }
};

export default dashboardReducer;